// <sm-batch-lookup endpoint="..."> wraps the batch number form.
// No backend exists yet (HANDOFF 7.10 "static result by default"): submitting
// keeps the page in place and shows the result box already rendered below.
// A future endpoint can be wired through the optional "endpoint" attribute.
class SmBatchLookup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.onSubmit = (event) => {
      event.preventDefault();
      const endpoint = this.getAttribute('endpoint');
      const result = this.querySelector('[data-batch-result]');
      if (!endpoint || !result) return;
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };
    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }
}

if (!customElements.get('sm-batch-lookup')) {
  customElements.define('sm-batch-lookup', SmBatchLookup);
}
